import { Drawer, Space } from '@conexasaude/conexa-hero'
import { Inbox } from '@talkjs/react'
import { useStyles } from './InboxDrawer.styles'
import { LoadingChat } from '../LoadingChat'
import { useInboxDrawer } from './InboxDrawer.hook'
import { InboxHeader } from './InboxHeader'
import { RenderIf } from '@/components/RenderIf'

export const InboxDrawer = () => {
  const styles = useStyles()
  const {
    openInboxDrawer,
    handleCloseDrawer,
    conversation,
    inboxRef,
    professionalData,
    handleOnConversationSelected,
    handleOnLeaveConversation,
    loading,
  } = useInboxDrawer()

  return (
    <Drawer
      title={
        <>
          <RenderIf condition={!!professionalData}>
            <InboxHeader
              professionalName={professionalData?.professionalName}
              goBack={handleOnLeaveConversation}
            />
          </RenderIf>

          <RenderIf condition={!professionalData}>Conversas</RenderIf>
        </>
      }
      position="right"
      hideFooter
      withCloseButton
      onClose={handleCloseDrawer}
      opened={openInboxDrawer}
    >
      <RenderIf condition={loading}>
        <Space mt="xs" />
        <LoadingChat />
      </RenderIf>

      <Inbox
        syncConversation={conversation}
        inboxRef={inboxRef}
        loadingComponent={<LoadingChat />}
        css={styles.inbox}
        onConversationSelected={handleOnConversationSelected}
        showChatHeader={false}
        showFeedHeader={false}
        showMobileBackButton={false}
      />
    </Drawer>
  )
}
